export const conditionExperienceColours = [
  {
    background: "lightCyan",
    colour: "skyBlue"
  },
  {
    background: "lavendar",
    colour: "plum"
  },
  {
    background: "lighterCyan",
    colour: "lightBlue2"
  }
];

export const servicesColours = [
  {
    background: "peachpuff",
    colour: "sandybrown"
  },
  {
    background: "lighterGreen",
    colour: "lightGreen"
  },
  {
    background: "mistyrose",
    colour: "lightCoral"
  }
];
